import { render, staticRenderFns } from "./DirectCandidateView.vue?vue&type=template&id=3eef839d"
import script from "./DirectCandidateView.vue?vue&type=script&lang=js"
export * from "./DirectCandidateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports